import React from "react";
import { useGroupContext } from "../../../lib/context/Groups/GroupContext";

import { HandleRequestState } from "../../shared/HandleRequestState/HandleRequestState";
import { GroupTable } from "./GroupTable/GroupTable";
import { HandleLoadingState } from "../../shared/HandleLoadingState/HandleLoadingState";
import { LoadingBox } from "../../shared/LoadingBox/LoadingBox";

import "./GroupsList.scss";

export const GroupsList = () => {
  const { groups, loadingGroups, errorGroups } = useGroupContext();

  return (
    <div className="GroupsList">
      <h5>Workspace groups ({groups?.length || 0})</h5>
      <span className="GroupsList__subTitle mb-3">
        Create and manage groups of users
      </span>

      <div className="GroupsList__content">
        <HandleLoadingState
          loading={loadingGroups}
          loadingPlaceholder={<LoadingBox count={3} minHeight={70} />}
        >
          <HandleRequestState
            state={errorGroups !== undefined}
            placeholder={<div>Error fetching groups</div>}
          >
            <GroupTable groups={groups || []} />
          </HandleRequestState>
        </HandleLoadingState>
      </div>
    </div>
  );
};
